import { Seo } from "@/components/Seo";
import { Reveal, PillButton, Hairline, StatusBadge } from "@/components/primitives";
import { StrategicAssetsNav } from "@/components/StrategicAssetsNav";

const SECTIONS = [
  { t: "Property & Financial Evidence", d: "Research connects property, ownership, liens, and financial records to the questions that determine whether an asset-related opportunity merits further examination." },
  { t: "Income-Tax Preparation · Steward & Stone", d: "Personal and business income-tax preparation belongs within Steward & Stone. Strategic Assets supplies the property and transaction context relevant to its own area of responsibility." },
];

const FUTURE = [
  "Asset & opportunity research across distressed and overlooked positions",
  "Mispricing and surplus signal analysis",
  "Broader portfolio and asset-class intelligence",
];

export default function SAIntelligence() {
  return (
    <div className="glow-navy jmh-page">
      <Seo title="Strategic Assets Intelligence — Strategic Assets" description="Strategic Assets Intelligence examines property, ownership, and financial evidence. Personal and business income-tax preparation belongs in Steward & Stone." />
      <StrategicAssetsNav />

      <section className="text-center jmh-section jmh-page-opening">
        <Reveal>
          <StatusBadge status="In development" className="mb-5" />
          <h1 className="font-serif2 text-4xl md:text-5xl text-[var(--bone)] leading-tight">Strategic Assets Intelligence</h1>
          <p className="mt-6 mx-auto text-lg md:text-xl text-[var(--bone)]/85 leading-relaxed">
            Sound property and asset decisions require a documented assessment of ownership, obligations, value, and uncertainty. Strategic Assets examines those relationships to determine which questions the evidence can resolve and which require further investigation. Broader research capabilities remain in development.
          </p>
        </Reveal>
      </section>

      <section className="jmh-section">
        <div className="mx-auto jmh-content-shell">
          <Reveal><Hairline className="opacity-70 mb-12" /></Reveal>
          <div className="jmh-content-grid">
            {SECTIONS.map((s, i) => (
              <Reveal key={s.t} delay={i * 0.05}>
                <div className="corner-frame px-7 py-8 h-full">
                  <h3 className="font-serif2 text-xl md:text-2xl text-[var(--bone)]">{s.t}</h3>
                  <p className="mt-4 text-sm md:text-base text-[var(--bone)]/75 leading-relaxed">{s.d}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.1} className="mt-12">
            <div className="corner-frame px-7 py-8">
              <div className="flex items-center gap-4 flex-wrap">
                <StatusBadge status="In development" />
                <h3 className="font-serif2 text-lg md:text-xl text-[var(--bone)]">Broader Asset & Opportunity Research</h3>
              </div>
              <ul className="mt-5 space-y-3">
                {FUTURE.map((f) => (
                  <li key={f} className="flex gap-3 text-sm md:text-base text-[var(--bone)]/70 leading-relaxed">
                    <span className="text-[var(--gold)] mt-0.5">•</span>
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <p className="mt-5 font-display uppercase tracking-wide2 text-[10px] text-[var(--muted)] leading-relaxed">
                These capabilities are in development and are not yet operational.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.15} className="mt-12 text-center">
            <PillButton to="/steward-and-stone" testid="sa-intel-tax">Explore Steward & Stone</PillButton>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
